import http from "utils/http";
import { digiStability } from "constants/endpoints";

const getDigiStabilityToolTypes = () => {
  const ENDPOINT = digiStability.getDigiStabilityToolTypes();
  const { REACT_APP_API_BASE_URL: API_BASE_URL } = process.env;
  return http.get(`${API_BASE_URL}${ENDPOINT}`);
};

export default getDigiStabilityToolTypes;
